var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section tables"},[_c('table-form',{attrs:{"type":'create'},on:{"itemSubmitSuccess":_vm.onItemSubmitSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }